import { render, staticRenderFns } from "./SurveillancePage.vue?vue&type=template&id=341b99b8&scoped=true&"
import script from "./SurveillancePage.vue?vue&type=script&lang=js&"
export * from "./SurveillancePage.vue?vue&type=script&lang=js&"
import style0 from "./SurveillancePage.vue?vue&type=style&index=0&id=341b99b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b99b8",
  null
  
)

export default component.exports